<template>
    <CButtonCombined :key="activeItem" :active="activeItem" :items="items" :size="size" @submit="submit" />
</template>

<script setup lang="ts">
import { useModal } from 'vue-final-modal'

import { EntityType } from '#shared/types/EntityType'
import { UserProfileType } from '#shared/types/User'
import { VisibilityType } from '#shared/types/visibility'
import AcceptProfileVisibilityChangeModal from '@/components/profile/modals/AcceptProfileVisibilityChangeModal.vue'
import { CButtonSizes } from '@/types/buttons'
import type { CButtonCombinedType } from '@/components/ui/CButtonCombined.vue'
import { mentorProfileVisibilityButtonItems, volunteerProfileVisibilityButtonItems, menteeProfileVisibilityButtonItems } from '@/types/visibility'

const props = defineProps({
    profileId: {
        type: String,
        required: true
    },
    slug: {
        type: String,
        required: true
    },
    type: {
        type: String as () => UserProfileType,
        required: true
    },
    modelValue: {
        type: String as () => VisibilityType,
        required: true
    },
    size: {
        type: String as () => CButtonSizes,
        default: CButtonSizes.Large as CButtonSizes
    }
})

const emit = defineEmits<{
    'update:modelValue': [value: VisibilityType]
}>()

const items = computed<CButtonCombinedType[]>(() => {
    if (props.type === EntityType.Mentor || props.type === 'mentor') {
        return mentorProfileVisibilityButtonItems
    }
    if (props.type === EntityType.Mentee || props.type === 'mentee') {
        return menteeProfileVisibilityButtonItems
    }
    return volunteerProfileVisibilityButtonItems
})

const activeItem = computed(() => {
    const index = items.value.findIndex((item) => item.id === props.modelValue)
    return index >= 0 ? index : 0
})

const submit = (index: number) => {
    const value = items.value[index].id as VisibilityType
    const { open, close } = useModal({
        component: AcceptProfileVisibilityChangeModal,
        attrs: {
            profileId: props.profileId,
            slug: props.slug,
            type: props.type,
            value,
            onSubmit: async () => {
                emit('update:modelValue', value)
                close()
                return true
            }
        }
    })
    open()
}
</script>